"use client"

import { KeyRound, LogOut, User } from "lucide-react"
import React, { useContext } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";
import axios from "axios";
import { base_url } from "../../config";
import setAuthToken from "../../authtoken";

const ChangePasword = ({ open, onClose }) => {

    const [notification, setNotification] = React.useState(null);
    if (!open) return null;
    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;

        const newPassword = form.newPassword.value;
        const confirmPassword = form.confirmPassword.value;

        if (newPassword !== confirmPassword) {
            setNotification({ type: "error", message: "New passwords do not match." });
            return;
        }
        try {
            await axios.post(`${base_url}/api/change_password`, {
                password: newPassword,
            });
            setNotification({ type: "success", message: "Password changed successfully." });
            setTimeout(() => {
                setNotification(null);
                onClose();
            }, 1500);
        } catch (err) {
            setNotification({
                type: "error",
                message:
                    err?.response?.data?.error ||
                    "Failed to change password. Please try again.",
            });
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div
                className="bg-white rounded-lg shadow-lg p-8 w-full max-w-4xl relative"
                style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                    aria-label="Close"
                >
                    ×
                </button>
                <div className="p-6 max-w-3xl mx-auto">
                    {notification && (
                        <div
                            className={`mb-4 px-4 py-2 rounded ${notification.type === "success"
                                ? "bg-green-100 text-green-800"
                                : "bg-red-100 text-red-800"
                                }`}
                        >
                            {notification.message}
                        </div>
                    )}
                    <form className="space-y-6" onSubmit={handleSubmit}>
                        <h2 className="text-xl font-bold mb-4">Change Password</h2>
                        <div>
                            <label className="block text-sm font-medium mb-1" htmlFor="newPassword">
                                New Password
                            </label>
                            <input
                                type="password"
                                name="newPassword"
                                id="newPassword"
                                required
                                className="w-full border rounded px-3 py-2"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1" htmlFor="confirmPassword">
                                Confirm New Password
                            </label>
                            <input
                                type="password"
                                name="confirmPassword"
                                id="confirmPassword"
                                required
                                className="w-full border rounded px-3 py-2"
                            />
                        </div>
                        <div className="flex justify-end gap-2">
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                            >
                                Change Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

const Header = () => {


    const { setScreen, setAuthenticated, isImpersonating, setError, reload, setReload, screen, isAdmin } =
        useContext(RegistrationContext);
    const [showChangePassword, setShowChangePassword] = React.useState(false);
    const handleLogout = async () => {
        setError("");
        try {
            await axios.post(`${base_url}/api/logout`, {});
            setAuthenticated(false);
            localStorage.removeItem("token");
            setAuthToken(false);
            setScreen("login");
            setReload(reload + 1);
        } catch (error) {
            console.error(error);
            setAuthenticated(false);
            localStorage.removeItem("token");
            setAuthToken(false);
            setScreen("login");
            setReload(reload + 1);
        }
    };
    const handleLeaveImpersonation = async () => {
        setError("");
        try {
            await axios.post(`${base_url}/api/leave_impersonation`, {});
            setReload(reload + 1);
        } catch (error) {
            console.error(error);
            setReload(reload + 1);
        }
    };

    const jumpToAdmin = async () => {
        setError("");
        try {
            await axios.post(`${base_url}/api/jump`, {
                step: "admin-dashboard",
            });

            setReload(reload + 1);
        } catch (error) {


        }
    };

    const jumpToUser = async () => {
        setError("");
        try {
            await axios.post(`${base_url}/api/jump`, {
                step: "Confirmation",
            });

            setReload(reload + 1);
        } catch (error) {


        }
    };

    const handleChangePassword = () => {
        setShowChangePassword(true);

    }

    const isAdminScreen = screen.startsWith("admin");
    const headerClass = isImpersonating
        ? "bg-yellow-400 shadow-sm"
        : isAdminScreen
            ? "bg-gradient-to-b from-slate-950 to-slate-900 border-b border-slate-800 shadow-sm"
            : "bg-white shadow-sm";

    const titleMain = isAdminScreen ? "text-slate-100" : "";
    const titleAccent = isAdminScreen ? "text-blue-400 font-extrabold" : "text-blue-600 font-extrabold";
    const titleSub = isAdminScreen ? "text-slate-400" : "text-gray-500";

    const ghostBtn = isAdminScreen
        ? "flex items-center bg-slate-800/60 text-blue-300 hover:bg-slate-800 border border-slate-700/60 font-medium py-2 px-6 rounded-lg transition-colors"
        : "flex items-center bg-white text-blue-600 border-blue-600 font-medium py-2 px-6 rounded-lg transition-colors";

    return (
        <header className={headerClass}>

            <div className="container mx-auto px-4 py-4 flex justify-between items-center">
                <div className="flex items-center">
                    <h1 className={`text-xl font-bold tracking-tight ${titleMain}`}>
                        <span className="font-extrabold">IJCAI</span>
                        <span className={titleAccent}> Registration</span>
                        <span className={`block text-sm font-medium -mt-1 ${titleSub}`}>System</span>
                    </h1>
                </div>

                <div className="flex items-center gap-6">
                    {isAdmin && !isAdminScreen && (
                        <button onClick={() => jumpToAdmin()} className={ghostBtn}>
                            <User className="h-4 w-4 mr-1" />
                            Admin
                        </button>
                    )}
                    {isAdmin && isAdminScreen && (
                        <button onClick={() => jumpToUser()} className={ghostBtn}>
                            <User className="h-4 w-4 mr-1" />
                            User
                        </button>
                    )}

                    <button onClick={() => handleChangePassword()} className={ghostBtn}>
                        <KeyRound className="h-4 w-4 mr-1" />
                        Change Password
                    </button>

                    {isImpersonating ? (
                        <button onClick={() => handleLeaveImpersonation()} className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors">
                            <LogOut className="h-4 w-4 mr-1" />
                            Leave Impersonation
                        </button>
                    ) : (
                        <button onClick={() => handleLogout()} className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors">
                            <LogOut className="h-4 w-4 mr-1" />
                            Log out
                        </button>
                    )}

                    <ChangePasword open={showChangePassword} onClose={() => setShowChangePassword(false)} />
                </div>
            </div>
        </header >
    );

}

export default Header;